import { Pokemon } from "../components/pokemonDetail"

const PokemonDetail = () => {
    return(
        <div>
            <Pokemon></Pokemon>
        </div>
    )
}

export { PokemonDetail }